import { useQuery } from '@tanstack/react-query';
import { t } from 'i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
  CURSOR_QUERY_PARAM,
  DataTable,
  LIMIT_QUERY_PARAM,
} from '@/components/ui/data-table';
import { TableTitle } from '@/components/ui/table-title';
import { AdminMcp, SeekPage } from '@activepieces/shared';
import { adminApi } from '@/features/internal-admin/lib/admin-api';
import { useAdminMcpsTable } from '@/features/internal-admin/lib/admin-mcps-table';

const AdminMcpsPage = () => {
  const { columns, filters } = useAdminMcpsTable();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const queryParams = {
    cursor: searchParams.get(CURSOR_QUERY_PARAM) || undefined,
    limit: Number(searchParams.get(LIMIT_QUERY_PARAM)) || 10,
    search: searchParams.get('name') ?? undefined,
    externalId: searchParams.get('externalIds') ?? undefined,
    externalCustomerId: searchParams.get('externalCustomerId') ?? undefined,
  };

  const { data, isLoading, isError } = useQuery<SeekPage<AdminMcp>, Error>({
    queryKey: ['admin-mcps', queryParams],
    queryFn: () => adminApi.listMcps(queryParams),
  });

  if (isError) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-destructive">{t('Failed to load MCPs')}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full">
      <TableTitle>{t('MCPs')}</TableTitle>
      <DataTable
        columns={columns}
        page={data}
        isLoading={isLoading}
        filters={filters}
        onRowClick={(row, newWindow) => {
          const url = `/internal-admin/mcps/${row.tenantId}/${row.id}`;
          if (newWindow) {
            window.open(url, '_blank');
          } else {
            navigate(url);
          }
        }}
      />
    </div>
  );
};

export default AdminMcpsPage;
